import i18next, { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import femalePlaceholder from "../../../assets/images/blurred2/female/1.webp";
import malePlaceholder from "../../../assets/images/blurred2/male/1.webp";
import originalFemale from "../../../assets/images/original/female/1.webp";
import originalMale from "../../../assets/images/original/male/1.webp";
import Footer from "../../../components/Footer";
import ImageButton from "../../../components/ImageButton";
import MobileViewLayout from "../../../layouts/MobileViewLayout";

const malePreloadImages = [
  "/staging/male/Age_1.png",
  "/staging/male/Age_2.png",
  "/staging/male/Age_3.png",
  "/staging/male/Age_4.png",
];

const femalePreloadImages = [
  "/staging/female/Age_1.png",
  "/staging/female/Age_2.png",
  "/staging/female/Age_3.png",
  "/staging/female/Age_4.png",
];

const data = [
  {
    image: originalMale,
    buttonText: t("common_text.male"),
    imagesToPreload: malePreloadImages,
    placeHolderImage: malePlaceholder,
    navigateTo: "/male/ageselection",
    buttonClasses: "btn btn-primary py-2 w-100 bgSecondary secondaryTextSize",
  },
  {
    image: originalFemale,
    buttonText: t("common_text.female"),
    imagesToPreload: femalePreloadImages,
    placeHolderImage: femalePlaceholder,
    navigateTo: "/female/ageselection",
    buttonClasses: "btn btn-success py-2 w-100 bgPrimary secondaryTextSize",
  },
];

const GenderSelection = ({ text }) => {
  return (
    <>
      <MobileViewLayout>
        <div className="genderDiv px-3">
          <h2
            className={`text-black fw-bold text-center ${
              text ? "fs20" : i18next.language === "en" ? "fs20" : "fs24"
            } gender-heading m-0`}
          >
            <Trans
              components={{ tag: <br /> }}
              i18nKey={text ? text : "landing_page.personalized_freelance_plan"}
            />
          </h2>
          <p className="pb-3 m-0 text-center fs18 select-gender-text">
            <Trans i18nKey={"landing_page.select_text"} />
          </p>
          <div className="d-flex justify-content-around align-items-center">
            {data.map((item, index) => (
              <ImageButton
                key={index}
                buttonClasses={"text-capitalize"}
                highlightButton={"image-button-highlight"}
                imageStyle={{ width: "100%", minHeight: "97px" }}
                {...item}
              />
            ))}
          </div>
        </div>
      </MobileViewLayout>
      <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-end pt-2 px-0 pb-2 ">
        <hr style={{ width: "100%" }} />
        <Footer />
      </div>
    </>
  );
};

export default GenderSelection;
